import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters([
      'getCurrentUser',
      'getErrors',
    ]),

    currentUser() {
      return this.getCurrentUser;
    },
    errors() {
      return this.getErrors;
    }
  },
}
